import type { StackProps } from '@chakra-ui/react';
import { GasFee } from '@ui/components/SwapDialog/GasFee';
import { Token, useNormalTokenConfig } from '@ui/config/token';
import { GAS_TOKEN } from '@ui/config/token/tokenConfig';
import { useTokenConfig } from '@ui/hooks/contracts/useTokenConfig';
import { useH2SwapGasFee } from '@ui/hooks/h2/useH2SwapGasFee';
import { useTokenPrice } from '@ui/hooks/tokenPrice';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';

import { useH2SwapForm } from './components/H2SwapForm/useH2SwapForm';
import { useH2SwapDialog } from './useH2SwapDialog';

export const H2SwapGasFee = (props: StackProps) => {
  const fromToken = useH2SwapForm((s) => s.fromToken);
  const agentTokenAddress = useH2SwapDialog((s) => s.agentTokenAddress);
  const fromTokenConfig = useTokenConfig({
    token: fromToken,
    tokenAddress: fromToken === Token.Agent ? agentTokenAddress : undefined,
  });

  const chainLayer = useGlobalChainLayer();
  const gasTokenInfo = useNormalTokenConfig()[GAS_TOKEN[chainLayer]];

  const gasPrice = useTokenPrice({
    token: GAS_TOKEN[chainLayer],
  }).data?.usd_price;
  const { data, isFetching } = useH2SwapGasFee(
    fromTokenConfig?.address ?? '',
    agentTokenAddress,
  );

  return (
    <GasFee
      data={data ? { gasFee: data, success: true } : undefined}
      gasTokenInfo={gasTokenInfo}
      gasPrice={gasPrice}
      isFetching={isFetching}
      {...props}
    />
  );
};
